export default __webpack_public_path__ + "static/blog3-a2e57eba995428852ec410f6a13ced57.jpg";